import { useMemo } from "react";

// Lightweight markdown renderer for summaries (bold, headings, bullets).
export default function Markdown({ text, className = "" }) {
  const blocks = useMemo(() => parse(text || ""), [text]);
  return (
    <div className={`prose-study text-[15px] text-slate-700 dark:text-slate-300 space-y-2 ${className}`}>
      {blocks.map((b, i) => {
        if (b.type === "h") {
          return (
            <h4 key={i} className="font-display font-bold text-slate-900 dark:text-slate-100 text-base mt-3">
              {inline(b.content)}
            </h4>
          );
        }
        if (b.type === "ul") {
          return (
            <ul key={i} className="list-disc pl-5 space-y-1.5">
              {b.items.map((it, j) => (
                <li key={j}>{inline(it)}</li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{inline(b.content)}</p>;
      })}
    </div>
  );
}

function parse(text) {
  const lines = text.replace(/\r/g, "").split("\n");
  const blocks = [];
  let list = null;
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (!line.trim()) {
      if (list) {
        blocks.push({ type: "ul", items: list });
        list = null;
      }
      continue;
    }
    const bullet = line.match(/^\s*[-*•]\s+(.*)$/);
    const heading = line.match(/^#{1,4}\s+(.*)$/);
    if (bullet) {
      list = list || [];
      list.push(bullet[1]);
    } else if (heading) {
      if (list) { blocks.push({ type: "ul", items: list }); list = null; }
      blocks.push({ type: "h", content: heading[1] });
    } else {
      if (list) { blocks.push({ type: "ul", items: list }); list = null; }
      blocks.push({ type: "p", content: line });
    }
  }
  if (list) blocks.push({ type: "ul", items: list });
  return blocks;
}

function inline(text) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    const m = p.match(/^\*\*([^*]+)\*\*$/);
    if (m) return <strong key={i}>{m[1]}</strong>;
    return <span key={i}>{p}</span>;
  });
}
